import styled from '@emotion/styled';
import { BodyWrapper } from '@components/templates/PageBody';
import { backgrounds } from '@assets/backgrounds';
import { icons } from '@assets/icons';

export const SupportBodyWrapper = styled(BodyWrapper)`
  overflow: auto;
`;

export const SupportTable = styled.table`
  width: 100%;
  margin-top: 10px;
  border-collapse: collapse;
  tbody {
    background: url(${backgrounds.support}) no-repeat center center;
    background-size: cover;
    tr > td {
      width: 50%;
      min-height: 320px;
      padding: 2.5% 4%;
      h1 {
        margin: 10px 0;
        font-size: 24px;
        line-height: 35px;
      }
      h4 {
        margin: 10px 0 40px;
        line-height: 23px;
        font-size: 16px;
        font-weight: normal;
      }
      &:nth-of-type(1) {
        text-align: center;
        background: rgba(127, 226, 0, 0.1);
      }
      &:nth-of-type(2) {
        text-align: left;
        background: rgba(250, 250, 250, 0.4);
      }
    }
  }
`;
export const ContactButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  a {
    width: 180px;
    height: 48px;
    line-height: 48px;
    margin: 0 5px;
    font-size: 18px;
    text-decoration: none;
    border-radius: 50px;
    background: #00bf00;
    color: #ffffff;
    &:hover {
      background: #2de100;
    }
    &:active {
      background: #62c121;
    }
    &:disabled {
      cursor: not-allowed;
      background-color: #999999;
      &:hover {
        background: #999999;
      }
      &:active {
        background: #999999;
      }
    }
  }
`;

export const HeuronInfoWrapper = styled.div``;
export const SupportLogoImg = styled.img`
  width: 249px;
  height: auto;
  margin: 0 0 30px;
`;
export const SupportContactsImg = styled.img`
  width: 100%;
  max-width: 651px;
  height: auto;
`;

export const SupportContacts = styled.ul`
  display: flex;
  flex-wrap: wrap;
  & li {
    padding-left: 20px;
    font-size: 14px;
    background-repeat: no-repeat;
    background-position: left 4px;
    color: #555;
    &.icon-ceo {
      width: 100%;
      margin-bottom: 10px;
      background-image: url(${icons.iconWho});
    }
    &.icon-location {
      width: 100%;
      margin-bottom: 20px;
      background-image: url(${icons.iconLocation});
    }
    &.icon-tel {
      margin-right: 20px;
      background-image: url(${icons.iconTel});
    }
    &.icon-fax {
      margin-right: 20px;
      background-image: url(${icons.iconFax});
    }
    &.icon-business {
      background-image: url(${icons.iconBusiness});
    }
  }
`;
export const DownloadSection = styled.section`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 30px;
  font-size: 14px;
  font-weight: bold;
  line-height: 20px;
  color: #777777;
`;
export const DownloadButton = styled.button`
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 49%;
  height: 40px;
  border: 1px solid #e0e0e0;
  font-size: 14px;
  font-weight: bold;
  background: #ffffff;
  color: #777;
  cursor: pointer;
  & + button {
    margin-left: auto;
  }
  & > img {
    width: 19px;
    height: 24px;
    margin: 0 10px;
  }

  & .superscript {
    font-size: 10px;
    vertical-align: super;
  }
`;
